import { UI, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { useRecoilQuery } from '../../../../../../hooks/useRecoilQuery';
import { orderInteractionChannelAuditQueryUpdated } from '../../../../../../store/order/selectors';

export interface ChannelSelectionProps {
  selectedValue?: string;
  onValueChange: (value: string) => void;
  setChannelAuditSelected: (value: number) => void;
  forceMobile?: boolean;
}

export const ChannelSelection: React.FC<ChannelSelectionProps> = ({
  selectedValue,
  onValueChange,
  setChannelAuditSelected,
  forceMobile,
}) => {
  const { data, loading } = useRecoilQuery(orderInteractionChannelAuditQueryUpdated);

  const channelsOptions = data?.[0]?.options || [];

  const handleValueChange = (value: string) => {
    setChannelAuditSelected(Number(data?.[0]?.value ?? 1));
    onValueChange(value);
  };

  return (
    <VStack space="inline.nano" flex={1}>
      <UI.Text variant="semibold">Canal de solicitação</UI.Text>
      <Box
        maxW={
          forceMobile ? 'full' : Utils.Responsive.PhoneTablet({ phone: 'full', tablet: '240px' })
        }
        w="full"
        bg="rgba(245, 245, 245, 1)"
        flex={1}
        maxH="42px"
        justifyContent="center"
        borderRadius={BoxBorder.heavy}>
        <UI.Select
          triggerProps={{
            isDisabled: loading || data?.length === 0,
            _disabled: { opacity: 0.2 },
            flex: 1,
          }}
          testID="select-channel"
          options={channelsOptions}
          placeholder={'Selecione o canal'}
          onValueChange={handleValueChange}
          selectedValue={selectedValue}
        />
      </Box>
    </VStack>
  );
};
